var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      ref: "axNavbar",
      staticClass: "ax-navbar",
      attrs: { id: "ax-navbar" },
      on: { blur: _vm.closeAll }
    },
    [
      _c("div", { staticClass: "ax-navbar__logo-container" }, [
        _c(
          "a",
          { attrs: { href: _vm.homeUrl, title: "Home" } },
          [_c("ClassLogo")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ax-navbar__links-container" }, [
        _c(
          "nav",
          {
            staticClass: "ax-navbar__nav",
            attrs: {
              id: "primary-nav-menu",
              role: "navigation",
              "aria-label": "primary-nav-menu"
            }
          },
          _vm._l(_vm.menuBar.menus, function(menu, index) {
            return _c("menu-item", {
              key: menu.caption,
              attrs: {
                id: menu.caption + "-menu",
                caption: menu.caption,
                items: menu.menuItems,
                menuIndex: index,
                secondLevelIsOpen: _vm.secondLevelIsOpen
              },
              on: {
                "toggle-dropdown": _vm.toggleSecondLevelOpen,
                "menu-hovering": _vm.setActiveItemIndex,
                navigate: _vm.navigate
              }
            })
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ax-navbar__actions-container" }, [
        _vm.scopeIsFund
          ? _c(
              "div",
              { staticClass: "ax-navbar__actions-group" },
              [_c("action-bar", { attrs: { baseUrl: _vm.baseUrl } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ax-navbar__actions-group" },
          [
            _c("user-bar", {
              attrs: {
                username: _vm.username,
                clientViewUrl: _vm.clientViewPath
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ax-navbar__toggle-container" }, [
        _c(
          "label",
          {
            staticClass: "ax-toggle ax-toggle--label-left",
            attrs: { for: "axToggleCheckbox" }
          },
          [
            _c("span", { staticClass: "ax-toggle__label-text" }, [
              _vm._v("NEW CLASS")
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "ax-toggle__checkbox",
              attrs: {
                type: "checkbox",
                id: "axToggleCheckbox",
                tabindex: "0"
              },
              on: { change: _vm.toggleNewFeature }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "ax-toggle__slider" })
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }